import { UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { TLM_MASTER } from "../apiRoutes";

// Define the expected response type (adjust based on your API response)
export interface TlmMaster {
  name: string;
  description: string;
  createdAt: string;
  isActive: boolean;
}

export interface TlmMasterResponse {
  data: {
    records: TlmMaster[];
    pagination: { totalRecords: number }[];
  }[];
}


const fetchTlmMaster = async ({ data }: { data: FieldValues }) => {
  const response = await axiosAuth.get<TlmMasterResponse>(TLM_MASTER, {
    params: data,
  });
  return response.data;
};

// Query hook
const useTlmMasterQuery = (
  data: FieldValues,
  queryParams?:
    | UseQueryOptions<TlmMasterResponse, Error, TlmMasterResponse, ["tlmMaster", FieldValues]>
    | UseMutationOptions<any, Error>
) =>
  useQuery<TlmMasterResponse, Error, TlmMasterResponse, ["tlmMaster", FieldValues]>({
    queryKey: ["tlmMaster", data],
    queryFn: () => fetchTlmMaster({ data }),
    ...(queryParams as any), // safely spread because TS can’t know if it's query or mutation
  });

export default useTlmMasterQuery;
